module.exports = __webpack_public_path__ + "static/media/funchal-10.205cf503.svg";